<template>
  <div
    class="px-12 pb-9 mt-6"
  >
    <v-btn
      @click="prevButtonFunction"
      color="#029F9A"
      tile
      class="px-9 white--text"
      height="50px"
    >
      <v-icon left>mdi-arrow-left</v-icon>
      {{ $t(prevButtonLabel) }}
    </v-btn>
    <v-btn
      v-if="nextButtonFunction !== undefined"
      @click="nextButtonFunction"
      color="#029F9A"
      tile
      class="px-9 float-right white--text"
      height="50px"
    >
      {{ $t(nextButtonLabel) }}
      <v-icon right>mdi-arrow-right</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'FooterNavigation',

  props: {
    prevButtonFunction: {
      type: Function,
      required: true,
    },
    prevButtonLabel: {
      type: String,
      required: true,
    },
    nextButtonFunction: {
      type: Function,
      required: false,
    },
    nextButtonLabel: {
      type: String,
      required: false,
    }
  },
};
</script>
<style scoped>
  .navigation-button {
    color: white !important;
  }
</style>